import { render, staticRenderFns } from "./UserGroups.vue?vue&type=template&id=7f9c5bc1&scoped=true&"
import script from "./UserGroups.vue?vue&type=script&lang=js&"
export * from "./UserGroups.vue?vue&type=script&lang=js&"
import style0 from "./UserGroups.vue?vue&type=style&index=0&id=7f9c5bc1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f9c5bc1",
  null
  
)

export default component.exports